import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Emoji, SuccessMessageWrapper } from "./styles/success-message-styles";
import { MessageText, CloseMessageButton } from "./styles/message-styles";

const SuccessMessage = ({ showMessage, clearSuccess }) => (
  <SuccessMessageWrapper showMessage={showMessage}>
    <Emoji>
      <span role="img" aria-label="party-popper-emoji">
        🎉
      </span>
    </Emoji>
    <MessageText>Successfully updated application status</MessageText>
    <CloseMessageButton
      onClick={clearSuccess}
      onKeyPress={clearSuccess}
      clearError
      role="button"
      tabIndex="0"
    >
      <FontAwesomeIcon icon={faTimes} />
    </CloseMessageButton>
  </SuccessMessageWrapper>
);

SuccessMessage.propTypes = {
  showMessage: PropTypes.bool.isRequired,
  clearSuccess: PropTypes.func.isRequired,
};

export default React.memo(SuccessMessage);
